module.exports = __webpack_public_path__ + "img/6C52AA_C9A6EA_A681D6_B494E2-256px.92d1c31f.png";